import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import ManagementCompaniesView from "@/features/R1Dashboard/views/ManagementCompaniesView";

export default function R1ManagementCompanies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | General Partners");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <ManagementCompaniesView />
      </main>
    </R1DashboardProvider>
  );
}
